import React from "react"
import CategoryRibbon from "../../components/CategoryRibbon"
import CollapsableCard, { CollapsableCardBody, CollapsableCardHeader } from "../../components/CollapsableCard/CollapsableCard"
import DataGrid from "../../components/DataGrid"
import { Column, RowData } from "../../components/DataGrid/types/types"
import { alphanumericCompare } from "../../services/utils/sort-util"
import { IFlashcard } from "./types"

const sortMethod = alphanumericCompare

const columns: Column[] = [
    {
        title: "CATEGORY", // This is actually "subcategory"
        dataProperty: "subcategory",
        sortable: true,
        sortMethod,
        width: "55%",
    },
    {
        title: "NEW",
        dataProperty: "new",
        sortable: true,
        sortMethod,
        width: "15%",
    },
    {
        title: "REVIEW AGAIN",
        dataProperty: "review",
        sortable: true,
        sortMethod,
        width: "15%",
    },
    {
        title: "MASTERED",
        dataProperty: "mastered",
        sortable: true,
        sortMethod,
        width: "15%",
    },
]

interface IFlashcardDecksWithSubcategoriesProps {
    category: string
    flashcards: IFlashcard[]
    onShowDeck: (category: string, status: string, subcategory: string) => void
}

interface ISet {
    setId: string
    setName: string
}

export default function FlashcardsDecksWithSubcategories(props: IFlashcardDecksWithSubcategoriesProps) {
    let {category, flashcards, onShowDeck} = props
    let uniqueSetIds = Array.from(new Set(flashcards.map(flashcard => flashcard.setId))).sort()
    let sets = uniqueSetIds.map(setId => flashcards.find(f => f.setId === setId)) as ISet[]

    const getCardBodyContent = (set: ISet) => {
        let {setId, setName} = set
        let flashcardsInSet = flashcards.filter(flashcard => flashcard.setId === setId)
        let subcategoriesInSet =  Array.from(new Set(flashcardsInSet.map(flashcard => flashcard.subcategory))).sort() as string[]
        let rows: RowData[] = subcategoriesInSet.map((subcategory, index) => {
            let subcategorizedFlashcards = flashcardsInSet.filter(f => f.subcategory === subcategory)
            let subcategoryDescription = subcategorizedFlashcards.length > 0 ? subcategorizedFlashcards[0].subcategoryDescription: "?"
            let flashcardsNew = subcategorizedFlashcards.filter(f => f.status === "new")
            let flashcardsReview = subcategorizedFlashcards.filter(f => f.status === "review")
            let flashcardsMastered = subcategorizedFlashcards.filter(f => f.status === "mastered")
            let hasNew = flashcardsNew.length > 0
            let hasReviewLater = flashcardsReview.length > 0
            let hasMastered = flashcardsMastered.length > 0
            let nofCardsNew = flashcardsNew.length
            let nofCardsReview = flashcardsReview.length
            let nofCardsMastered = flashcardsMastered.length
            let row: RowData = {
                id: `flashcard-row-${index}`,
                data: {
                    subcategory: {
                        content: () =>
                            <>
                                <p className="mb-1"><b>{subcategory}</b></p>
                                <p className="mb-0">{ subcategoryDescription}</p>
                            </>,
                        comparator: subcategory,
                    },
                    new: {
                        content: () => 
                            <div>
                                <button 
                                    className="btn btn--text-default btn--bg-blue" 
                                    disabled={!hasNew} 
                                    onClick={() => onShowDeck(category, "new", subcategory)}>LAUNCH DECK ({nofCardsNew})
                                </button>
                            </div>,
                        comparator: nofCardsNew
                    },
                    review: {
                        content: () => 
                            <div>
                                <button 
                                    className="btn btn--text-default btn--bg-green" 
                                    disabled={!hasReviewLater} 
                                    onClick={() => onShowDeck(category, "review", subcategory)}>LAUNCH DECK ({nofCardsReview})
                                </button>
                            </div>,
                        comparator: nofCardsReview
                    },
                    mastered: {
                        content: () => 
                            <div>
                                <button 
                                    className="btn btn--text-default btn--bg-purple" 
                                    disabled={!hasMastered} 
                                    onClick={() => onShowDeck(category, "mastered", subcategory)}>LAUNCH DECK ({nofCardsMastered})
                                </button>
                            </div>,
                        comparator: nofCardsMastered
                    }
                }
            }
            return row
        })

        return (
            <div className="">
                <DataGrid 
                    columns={columns}
                    data={rows}
                    className="flashcards-subcategory-grid lesson-header-theme--reading"
                />
            </div>
          )
    }

    return (
        <div className="flashcards-decks-container">
            <CategoryRibbon category={category}/>
            <div className="flashcards-decks-subcats">
                { sets.map((set) => 
                    <div className="flashcards-decks-subcats--group" id={`setkey-${set.setId}`}>
                        <h2 className="lesson-list-card-header--text">{set.setName}</h2>
                        <div>
                            {getCardBodyContent(set)}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
